@if (layer?.flightLevelValues?.()?.length! > 1) {
  <jmkw-flight-level-select
    [layer]="layer"
    (selectionChanged)="updateSelectedFlightLevel($event)"
  ></jmkw-flight-level-select>
}
@if (shouldShowTimeSpanSelect) {
  <jmkw-time-span-select
    [layer]="layer"
    [timeMultiplier]="timeMultiplier"
    (selectionChanged)="updateSelectedTime($event)"
  ></jmkw-time-span-select>
}
<div class="svg-wrapper">
  @if (data?.svgComponent; as svgComponent) {
    <ng-container
      [ngComponentOutlet]="svgComponent"
    ></ng-container>
  }
</div>
